import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemno', 'itemname', 'customer_id', 'CustName'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakerycustomerprice${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listcustprice(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemno', 'itemname', 'customer_id', 'CustName'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakerycustomerprice${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    lookup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get('/bakerycustomer');
                const {
                    list
                } = data;
                list.forEach(item => {
                    item.selected = false;
                });
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post('/bakerycustomerprice', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/bakerycustomerprice/${obj.tablekey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },

    exportxls(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemno', 'itemname', 'customer_id', 'CustName'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const response = await axios({
                url: `/bakerycustomerprice/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            });
            resolve(response);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}    
};